import { WarningSvg } from "./WarningSVG";
export default WarningSvg;
